import { render } from "./CostsCreate.vue?vue&type=template&id=188171dc&scoped=true"
import script from "./CostsCreate.vue?vue&type=script&lang=js"
export * from "./CostsCreate.vue?vue&type=script&lang=js"

import "./CostsCreate.vue?vue&type=style&index=0&id=188171dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188171dc"]])

export default __exports__